import * as Control$dMonad$dReader$dTrans from "../Control.Monad.Reader.Trans/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Specular$dDom$dBrowser from "../Specular.Dom.Browser/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dFRP$dWeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
const text = dict => dict.text;
const rawHtml = dict => dict.rawHtml;
const onDomEvent = dictMonadFRP => {
  const MonadCleanup1 = dictMonadFRP.MonadCleanup1();
  const bind = MonadCleanup1.Monad0().Bind1().bind;
  const liftEffect = dictMonadFRP.MonadEffect0().liftEffect;
  return eventType => node => handler => bind(liftEffect(Specular$dDom$dBrowser.addEventListenerImpl(eventType)(handler)(node)))(unsub => MonadCleanup1.onCleanup(unsub));
};
const liftBuilderWithRun = dict => dict.liftBuilderWithRun;
const liftBuilder = dict => dict.liftBuilder;
const elDynAttrNS$p = dict => dict["elDynAttrNS'"];
const elDynAttr$p = dictMonadDomBuilder => dictMonadDomBuilder["elDynAttrNS'"](Data$dMaybe.Nothing);
const elDynAttr = dictMonadDomBuilder => {
  const map1 = dictMonadDomBuilder.Monad0().Bind1().Apply0().Functor0().map;
  const elDynAttr$p1 = dictMonadDomBuilder["elDynAttrNS'"](Data$dMaybe.Nothing);
  return tagName => dynAttrs => inner => map1(Data$dTuple.snd)(elDynAttr$p1(tagName)(dynAttrs)(inner));
};
const elAttr$p = dictMonadDomBuilder => {
  const elDynAttr$p1 = dictMonadDomBuilder["elDynAttrNS'"](Data$dMaybe.Nothing);
  return tagName => attrs => inner => elDynAttr$p1(tagName)(Specular$dFRP$dWeakDynamic.applicativeWeakDynamic.pure(attrs))(inner);
};
const elAttr = dict => dict.elAttr;
const elAttr_ = dictMonadDomBuilder => {
  const pure2 = dictMonadDomBuilder.Monad0().Applicative0().pure;
  return tagName => attrs => dictMonadDomBuilder.elAttr(tagName)(attrs)(pure2());
};
const el$p = dictMonadDomBuilder => {
  const elAttr$p1 = elAttr$p(dictMonadDomBuilder);
  return tagName => inner => elAttr$p1(tagName)(Foreign$dObject.empty)(inner);
};
const el = dictMonadDomBuilder => tagName => inner => dictMonadDomBuilder.elAttr(tagName)(Foreign$dObject.empty)(inner);
const el_ = dictMonadDomBuilder => {
  const pure2 = dictMonadDomBuilder.Monad0().Applicative0().pure;
  return tagName => dictMonadDomBuilder.elAttr(tagName)(Foreign$dObject.empty)(pure2());
};
const dynText = dict => dict.dynText;
const monadDomBuilderReaderT = dictMonadDomBuilder => {
  const monadReaderT = Control$dMonad$dReader$dTrans.monadReaderT(dictMonadDomBuilder.Monad0());
  return {
    text: x => {
      const $0 = dictMonadDomBuilder.text(x);
      return v => $0;
    },
    dynText: x => {
      const $0 = dictMonadDomBuilder.dynText(x);
      return v => $0;
    },
    "elDynAttrNS'": ns => tag => attrs => body => env => dictMonadDomBuilder["elDynAttrNS'"](ns)(tag)(attrs)(body(env)),
    rawHtml: x => {
      const $0 = dictMonadDomBuilder.rawHtml(x);
      return v => $0;
    },
    elAttr: tag => attrs => body => env => dictMonadDomBuilder.elAttr(tag)(attrs)(body(env)),
    liftBuilder: b => {
      const $0 = dictMonadDomBuilder.liftBuilder(b);
      return v => $0;
    },
    liftBuilderWithRun: fn => e => dictMonadDomBuilder.liftBuilderWithRun((benv, run) => fn(
      benv,
      (benv$p, m) => {
        const $0 = m(e);
        return run(benv$p, $0);
      }
    )),
    Monad0: () => monadReaderT
  };
};
const dynRawHtml = dictMonadDomBuilder => {
  const rawHtml1 = dictMonadDomBuilder.rawHtml;
  return dictMonadReplace => {
    const weakDynamic_ = Specular$dFRP$dReplaceable.weakDynamic_(dictMonadReplace);
    return dictMonadFRP => {
      const weakDynamic_1 = weakDynamic_(dictMonadFRP);
      return dynHtml => weakDynamic_1(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.functorMaybe.map(rawHtml1))(dynHtml));
    };
  };
};
const domEventWithSample = dictMonadFRP => {
  const Monad0 = dictMonadFRP.MonadCleanup1().Monad0();
  const Bind1 = Monad0.Bind1();
  const newEvent = Specular$dFRP$dBase.newEvent(dictMonadFRP.MonadEffect0());
  const onDomEvent1 = onDomEvent(dictMonadFRP);
  const pure2 = Monad0.Applicative0().pure;
  return sample => eventType => node => Bind1.bind(newEvent)(v => {
    const $0 = v.event;
    return Bind1.bind(onDomEvent1(eventType)(node)(a => {
      const $1 = sample(a);
      return () => {
        const $2 = $1();
        return v.fire($2)();
      };
    }))(() => pure2($0));
  });
};
const domEvent = dictMonadFRP => domEventWithSample(dictMonadFRP)(v => () => {});
export {
  domEvent,
  domEventWithSample,
  dynRawHtml,
  dynText,
  el,
  el$p,
  elAttr,
  elAttr$p,
  elAttr_,
  elDynAttr,
  elDynAttr$p,
  elDynAttrNS$p,
  el_,
  liftBuilder,
  liftBuilderWithRun,
  monadDomBuilderReaderT,
  onDomEvent,
  rawHtml,
  text
};
